<template>
  <div v-if="get(context.nodeData.value[level], ['children', 'length'])" class="vehicle-selector-accordion-section">
    <button
      :class="['vehicle-selector-accordion-section__toggler', {'vehicle-selector-accordion-section__toggler--selection': !!selectedNode}]"
      :aria-controls="`${id}-content`"
      :aria-expanded="isExpanded"
      @click="isExpanded = !isExpanded">
      <span class="vehicle-selector-accordion-section__toggler-text">
        <template v-if="selectedNode">
          <oie-base-icon icon="checkmark-outline" size="s"></oie-base-icon>
          <oie-use-svg v-if="isRootNode && selectedNode.codeNameIcon" class="vehicle-selector-action__custom-icon" :svg="selectedNode.codeNameIcon"></oie-use-svg>
        </template>
        {{ selectedNode ? selectedNode.name : context.nodeData.value[level].node.channelNodeChoiceHelpText || tStatic('selectVehicleTypeLabel') }}
      </span>
      <oie-base-icon :rotate="isExpanded ? '180' : ''" icon="chevron-down" size="s"></oie-base-icon>
    </button>
    <div class="vehicle-selector-accordion-section__content" :inert="!isExpanded ? 'true' : null">
      <oie-vehicle-selector-section
        :id="`${id}-content`"
        v-bind="{ ...$props, ...$attrs, hideLegend: true }"
        v-on="$listeners"></oie-vehicle-selector-section>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch } from '@vue/composition-api'
import _ from 'lodash'

export default defineComponent({
  props: {
    level: {
      type: String,
      default: '0'
    },
    context: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const id = _.uniqueId('vehicle-selector-accordion-section-')
    const isExpanded = ref(true)
    const isRootNode = computed(() => props.level === '0')

    const selectedNode = computed(() => {
      return _.get(props.context.nodeData.value, [Number(props.level) + 1, 'node'], null)
    })

    watch(selectedNode, (newNode) => {
      if (newNode) {
        isExpanded.value = false
      }
    })

    return {
      isRootNode,
      isExpanded,
      id,
      selectedNode
    }
  }
})
</script>

<style lang="scss">
.vehicle-selector-accordion-section__toggler {
  @include reset-button;
  width: 100%;
  justify-content: space-between;
  text-decoration: none;
  min-height: 40px;
  height: 100%;
  padding: 0px 10px;
  background-color: #eff6fb;
  border: 1px solid #bbdff4;
}

.vehicle-selector-accordion-section__toggler--selection {
  background-color: color(background-light-green);
  border: 1px solid color(border-green-3);
}

.vehicle-selector-accordion-section__toggler-text {
  display: flex;
  align-items: center;
  gap: measure('quarter');
}

.vehicle-selector-accordion-section__content {
  transition: height 0.5s ease-out;
  height: auto;
  overflow: hidden;
}

.vehicle-selector-accordion-section__content[inert] {
  height: 0;
}

.vehicle-selector-accordion-section__content >*:first-child {
  margin-top: measure(quarter);
}

</style>
